import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';

import { Specialties } from './styles';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import { getSpecialtyItems } from '../../lib/utils';

type ProviderSpecialtiesProps = {
  /** The provider whose name is displayed. */
  provider: ProviderMatchProviderV9;
};

const ProviderSpecialties = ({
  provider
}: ProviderSpecialtiesProps): React.ReactElement | null => {
  const specialtiesItems = getSpecialtyItems(provider);

  if (specialtiesItems.length > 0) {
    return (
      <Specialties>
        {specialtiesItems.map((item: string, index: number) => (
          /* Using itemProp "knowsAbout" for provider specialties based on schema.org/Person definition: https://schema.org/Person.
          We don't use "medialSpecialty" because there is no mapping from our specialty types directly to the schema.org enum */
          <span key={item.toString() + index} itemProp="knowsAbout">
            {item}
          </span>
        ))}
      </Specialties>
    );
  }

  return null;
};

export default withErrorBoundary(ProviderSpecialties);
